import {
  components,
} from '@/generated/qmulus/openapi.ts';

export type TUnitSystem = 'metric' | 'imperial';

export enum EUnitOfMeasurement {
  UNIT_LESS = 0,
  PERCENT = 1,
  PARTS_PER_MILLION = 2,
  DEGREES_CELSIUS = 3,
  DEGREES_FAHRENHEIT = 4,
  DEGREES_KELVIN = 5,
  DELTA_DEGREES_CELSIUS = 6,
  DELTA_DEGREES_FAHRENHEIT = 7,
  DELTA_DEGREES_KELVIN = 8,
  PASCAL = 9,
  KILO_PASCAL = 10,
  BAR = 11,
  MILLIBAR = 12,
  MICROBAR = 13,
  PSI = 14,
  INCH_OF_WATER_COLUMN = 15,
  INCH_OF_MERCURY = 16,
  MILLIMETRE_OF_WATER_COLUMN = 17,
  MILLIMETRE_OF_MERCURY = 18,
  FEET_OF_WATER_COLUMN = 19,
  TORR = 20,
  MICRON_OF_MERCURY = 21,
  MILLILITRE_PER_MINUTE = 22,
  LITRE_PER_MINUTE = 23,
  LITRE_PER_HOUR = 24,
  CUBIC_CENTIMETRE_PER_MINUTE = 25,
  CUBIC_FEET_PER_MINUTE = 26,
  CUBIC_FEET_PER_HOUR = 27,
  CUBIC_METRE_PER_MINUTE = 28,
  CUBIC_METRE_PER_HOUR = 29,
  GALLONS_PER_MINUTE = 30,
  GALLONS_PER_HOUR = 31,
  AMPERE = 32,
  MILLI_AMPERE = 33,
  VOLT = 34,
  MILLIVOLT = 35,
  KILOVOLT = 36,
  WATT = 37,
  MEGAWATT = 38,
  KILOWATT = 39,
  VOLT_AMPERE = 40,
  KILOVOLT_AMPERE = 41,
  BTU_PER_MINUTE = 42,
  HORSEPOWER = 43,
  KILOWATT_HOUR = 44,
  BTU = 45,
  METRES_PER_SECOND = 46,
  METRES_PER_MINUTE = 47,
  RPM = 48,
  NUMBER = 49,
  DEGREES_CELSIUS_PER_MINUTE = 50,
  DEGREES_FAHRENHEIT_PER_MINUTE = 51,
  SECOND = 52,
  MINUTE = 53,
  HOUR = 54,
  BAR_PER_MINUTE = 55,
  MILLIBAR_PER_MINUTE = 56,
  MICROBAR_PER_MINUTE = 57,
  TORR_PER_MINUTE = 58,
  MICRON_HG_PER_MINUTE = 59,
  MICRON_HG_PER_HOUR = 60,
  TONNE = 61,
  KILOGRAM = 62,
  GRAM = 63,
  MILLIGRAM = 64,
  POUND = 65,
  KILOMETER = 66,
  METRE = 67,
  MILLIMETRE = 68,
  MICRON = 69,
  INCH = 70,
  MILLILITRE = 71,
  LITRE = 72,
  CUBIC_METRES = 73,
  CUBIC_FEET = 74,
  ATMOSPHERE = 75,
  WEIGHT_PERCENT = 76,
  CUBIC_METRE_PER_SECOND = 77,
  PERCENT_CARBON = 78,
  PERCENT_NITROGEN = 79,
  BTU_PER_HOUR = 80,
  DAY = 81,
  WEEK = 82,
  MONTH = 83,
  YEAR = 84,
  PERCENT_HYDROGEN = 85,
  VICKERS_HARDNESS = 86,
  VICKERS_HARDNESS_0_1 = 87,
  VICKERS_HARDNESS_0_2 = 88,
  VICKERS_HARDNESS_0_3 = 89,
  VICKERS_HARDNESS_0_4 = 90,
  VICKERS_HARDNESS_0_5 = 91,
  VICKERS_HARDNESS_0_6 = 92,
  VICKERS_HARDNESS_0_7 = 93,
  VICKERS_HARDNESS_0_8 = 94,
  VICKERS_HARDNESS_0_9 = 95,
  VICKERS_HARDNESS_1 = 96,
  VICKERS_HARDNESS_10 = 97,
  VICKERS_HARDNESS_20 = 98,
  VICKERS_HARDNESS_30 = 99,
  VICKERS_HARDNESS_40 = 100,
  VICKERS_HARDNESS_50 = 101,
  VICKERS_HARDNESS_60 = 102,
  VICKERS_HARDNESS_70 = 103,
  VICKERS_HARDNESS_80 = 104,
  VICKERS_HARDNESS_90 = 105,
  VICKERS_HARDNESS_100 = 106,
  ROCKWELL_HARDNESS = 107,
  ROCKWELL_HARDNESS_A = 108,
  ROCKWELL_HARDNESS_B = 109,
  ROCKWELL_HARDNESS_C = 110,
  ROCKWELL_HARDNESS_D = 111,
  ROCKWELL_HARDNESS_E = 112,
  ROCKWELL_HARDNESS_F = 113,
  ROCKWELL_HARDNESS_G = 114,
  ROCKWELL_HARDNESS_H = 115,
  ROCKWELL_HARDNESS_K = 116,
  ROCKWELL_HARDNESS_L = 117,
  ROCKWELL_HARDNESS_M = 118,
  ROCKWELL_HARDNESS_P = 119,
  ROCKWELL_HARDNESS_R = 120,
  ROCKWELL_HARDNESS_S = 121,
  ROCKWELL_HARDNESS_V = 122,
  ROCKWELL_HARDNESS_15_N = 123,
  ROCKWELL_HARDNESS_30_N = 124,
  ROCKWELL_HARDNESS_45_N = 125,
  ROCKWELL_HARDNESS_15_T = 126,
  ROCKWELL_HARDNESS_30_T = 127,
  ROCKWELL_HARDNESS_45_T = 128,
  ROCKWELL_HARDNESS_15_W = 129,
  ROCKWELL_HARDNESS_30_W = 130,
  ROCKWELL_HARDNESS_45_W = 131,
  ROCKWELL_HARDNESS_15_X = 132,
  ROCKWELL_HARDNESS_30_X = 133,
  ROCKWELL_HARDNESS_45_X = 134,
  ROCKWELL_HARDNESS_15_Y = 135,
  ROCKWELL_HARDNESS_30_Y = 136,
  ROCKWELL_HARDNESS_45_Y = 137,
  BRINELL_HARDNESS = 138,
  BRINELL_HARDNESS_10_500_15 = 139,
  BRINELL_HARDNESS_10_1500_15 = 140,
  BRINELL_HARDNESS_10_3000_15 = 141,
  BRINELL_HARDNESS_10_500_10 = 142,
  BRINELL_HARDNESS_10_1500_10 = 143,
  BRINELL_HARDNESS_10_3000_10 = 144,
  BRINELL_HARDNESS_6_500_15 = 145,
  BRINELL_HARDNESS_6_1500_15 = 146,
  BRINELL_HARDNESS_6_3000_15 = 147,
  BRINELL_HARDNESS_6_500_10 = 148,
  BRINELL_HARDNESS_6_1500_10 = 149,
  BRINELL_HARDNESS_6_3000_10 = 150,
  KNOOP_HARDNESS = 151,
  KNOOP_HARDNESS_200 = 152,
  KNOOP_HARDNESS_500 = 153,
  KNOOP_HARDNESS_50 = 154,
  KNOOP_HARDNESS_100 = 155,
  NORMAL_LITRE_PER_SQUARE_METERS_PER_HOUR = 156,
  MILLIMETRE_PER_SECOND = 157,
  KILOGRAM_PER_HOUR = 158,
  KILOGRAM_PER_MINUTE = 159,
  KILOGRAM_PER_SECOND = 160,
  GRAM_PER_SECOND = 161,
  HECTO_PASCAL = 162,
  MILLITORR_PER_HOUR = 163,
  FEET_PER_SECOND = 164,
  FEET_PER_MINUTE = 165,
  INCH_PER_SECOND = 166,
  INCH_PER_MINUTE = 167,
  CENTIMETRE_PER_SECOND = 168,
  CENTIMETRE_PER_MINUTE = 169,
  HERTZ = 170,
  THOUSANDTHS_OF_AN_INCH = 171,
  THOUSANDTHS_OF_WATER_COLUMN = 172,
  THOUSANDTHS_OF_MERCURY_COLUMN = 173,
  NEWTON_PER_SQUARE_MILLIMETRE = 174,
  VICKERS_HARDNESS_2 = 175,
  VICKERS_HARDNESS_5 = 176,
}

export const MeasurementUnitMap: Record<components['schemas']['UnitOfMeasurementType'], keyof typeof EUnitOfMeasurement> = {
  0: 'UNIT_LESS',
  1: 'PERCENT',
  2: 'PARTS_PER_MILLION',
  3: 'DEGREES_CELSIUS',
  4: 'DEGREES_FAHRENHEIT',
  5: 'DEGREES_KELVIN',
  6: 'DELTA_DEGREES_CELSIUS',
  7: 'DELTA_DEGREES_FAHRENHEIT',
  8: 'DELTA_DEGREES_KELVIN',
  9: 'PASCAL',
  10: 'KILO_PASCAL',
  11: 'BAR',
  12: 'MILLIBAR',
  13: 'MICROBAR',
  14: 'PSI',
  15: 'INCH_OF_WATER_COLUMN',
  16: 'INCH_OF_MERCURY',
  17: 'MILLIMETRE_OF_WATER_COLUMN',
  18: 'MILLIMETRE_OF_MERCURY',
  19: 'FEET_OF_WATER_COLUMN',
  20: 'TORR',
  21: 'MICRON_OF_MERCURY',
  22: 'MILLILITRE_PER_MINUTE',
  23: 'LITRE_PER_MINUTE',
  24: 'LITRE_PER_HOUR',
  25: 'CUBIC_CENTIMETRE_PER_MINUTE',
  26: 'CUBIC_FEET_PER_MINUTE',
  27: 'CUBIC_FEET_PER_HOUR',
  28: 'CUBIC_METRE_PER_MINUTE',
  29: 'CUBIC_METRE_PER_HOUR',
  30: 'GALLONS_PER_MINUTE',
  31: 'GALLONS_PER_HOUR',
  32: 'AMPERE',
  33: 'MILLI_AMPERE',
  34: 'VOLT',
  35: 'MILLIVOLT',
  36: 'KILOVOLT',
  37: 'WATT',
  38: 'MEGAWATT',
  39: 'KILOWATT',
  40: 'VOLT_AMPERE',
  41: 'KILOVOLT_AMPERE',
  42: 'BTU_PER_MINUTE',
  43: 'HORSEPOWER',
  44: 'KILOWATT_HOUR',
  45: 'BTU',
  46: 'METRES_PER_SECOND',
  47: 'METRES_PER_MINUTE',
  48: 'RPM',
  49: 'NUMBER',
  50: 'DEGREES_CELSIUS_PER_MINUTE',
  51: 'DEGREES_FAHRENHEIT_PER_MINUTE',
  52: 'SECOND',
  53: 'MINUTE',
  54: 'HOUR',
  55: 'BAR_PER_MINUTE',
  56: 'MILLIBAR_PER_MINUTE',
  57: 'MICROBAR_PER_MINUTE',
  58: 'TORR_PER_MINUTE',
  59: 'MICRON_HG_PER_MINUTE',
  60: 'MICRON_HG_PER_HOUR',
  61: 'TONNE',
  62: 'KILOGRAM',
  63: 'GRAM',
  64: 'MILLIGRAM',
  65: 'POUND',
  66: 'KILOMETER',
  67: 'METRE',
  68: 'MILLIMETRE',
  69: 'MICRON',
  70: 'INCH',
  71: 'MILLILITRE',
  72: 'LITRE',
  73: 'CUBIC_METRES',
  74: 'CUBIC_FEET',
  75: 'ATMOSPHERE',
  76: 'WEIGHT_PERCENT',
  77: 'CUBIC_METRE_PER_SECOND',
  78: 'PERCENT_CARBON',
  79: 'PERCENT_NITROGEN',
  80: 'BTU_PER_HOUR',
  81: 'DAY',
  82: 'WEEK',
  83: 'MONTH',
  84: 'YEAR',
  85: 'PERCENT_HYDROGEN',
  86: 'VICKERS_HARDNESS',
  87: 'VICKERS_HARDNESS_0_1',
  88: 'VICKERS_HARDNESS_0_2',
  89: 'VICKERS_HARDNESS_0_3',
  90: 'VICKERS_HARDNESS_0_4',
  91: 'VICKERS_HARDNESS_0_5',
  92: 'VICKERS_HARDNESS_0_6',
  93: 'VICKERS_HARDNESS_0_7',
  94: 'VICKERS_HARDNESS_0_8',
  95: 'VICKERS_HARDNESS_0_9',
  96: 'VICKERS_HARDNESS_1',
  97: 'VICKERS_HARDNESS_10',
  98: 'VICKERS_HARDNESS_20',
  99: 'VICKERS_HARDNESS_30',
  100: 'VICKERS_HARDNESS_40',
  101: 'VICKERS_HARDNESS_50',
  102: 'VICKERS_HARDNESS_60',
  103: 'VICKERS_HARDNESS_70',
  104: 'VICKERS_HARDNESS_80',
  105: 'VICKERS_HARDNESS_90',
  106: 'VICKERS_HARDNESS_100',
  107: 'ROCKWELL_HARDNESS',
  108: 'ROCKWELL_HARDNESS_A',
  109: 'ROCKWELL_HARDNESS_B',
  110: 'ROCKWELL_HARDNESS_C',
  111: 'ROCKWELL_HARDNESS_D',
  112: 'ROCKWELL_HARDNESS_E',
  113: 'ROCKWELL_HARDNESS_F',
  114: 'ROCKWELL_HARDNESS_G',
  115: 'ROCKWELL_HARDNESS_H',
  116: 'ROCKWELL_HARDNESS_K',
  117: 'ROCKWELL_HARDNESS_L',
  118: 'ROCKWELL_HARDNESS_M',
  119: 'ROCKWELL_HARDNESS_P',
  120: 'ROCKWELL_HARDNESS_R',
  121: 'ROCKWELL_HARDNESS_S',
  122: 'ROCKWELL_HARDNESS_V',
  123: 'ROCKWELL_HARDNESS_15_N',
  124: 'ROCKWELL_HARDNESS_30_N',
  125: 'ROCKWELL_HARDNESS_45_N',
  126: 'ROCKWELL_HARDNESS_15_T',
  127: 'ROCKWELL_HARDNESS_30_T',
  128: 'ROCKWELL_HARDNESS_45_T',
  129: 'ROCKWELL_HARDNESS_15_W',
  130: 'ROCKWELL_HARDNESS_30_W',
  131: 'ROCKWELL_HARDNESS_45_W',
  132: 'ROCKWELL_HARDNESS_15_X',
  133: 'ROCKWELL_HARDNESS_30_X',
  134: 'ROCKWELL_HARDNESS_45_X',
  135: 'ROCKWELL_HARDNESS_15_Y',
  136: 'ROCKWELL_HARDNESS_30_Y',
  137: 'ROCKWELL_HARDNESS_45_Y',
  138: 'BRINELL_HARDNESS',
  139: 'BRINELL_HARDNESS_10_500_15',
  140: 'BRINELL_HARDNESS_10_1500_15',
  141: 'BRINELL_HARDNESS_10_3000_15',
  142: 'BRINELL_HARDNESS_10_500_10',
  143: 'BRINELL_HARDNESS_10_1500_10',
  144: 'BRINELL_HARDNESS_10_3000_10',
  145: 'BRINELL_HARDNESS_6_500_15',
  146: 'BRINELL_HARDNESS_6_1500_15',
  147: 'BRINELL_HARDNESS_6_3000_15',
  148: 'BRINELL_HARDNESS_6_500_10',
  149: 'BRINELL_HARDNESS_6_1500_10',
  150: 'BRINELL_HARDNESS_6_3000_10',
  151: 'KNOOP_HARDNESS',
  152: 'KNOOP_HARDNESS_200',
  153: 'KNOOP_HARDNESS_500',
  154: 'KNOOP_HARDNESS_50',
  155: 'KNOOP_HARDNESS_100',
  156: 'NORMAL_LITRE_PER_SQUARE_METERS_PER_HOUR',
  157: 'MILLIMETRE_PER_SECOND',
  158: 'KILOGRAM_PER_HOUR',
  159: 'KILOGRAM_PER_MINUTE',
  160: 'KILOGRAM_PER_SECOND',
  161: 'GRAM_PER_SECOND',
  162: 'HECTO_PASCAL',
  163: 'MILLITORR_PER_HOUR',
  164: 'FEET_PER_SECOND',
  165: 'FEET_PER_MINUTE',
  166: 'INCH_PER_SECOND',
  167: 'INCH_PER_MINUTE',
  168: 'CENTIMETRE_PER_SECOND',
  169: 'CENTIMETRE_PER_MINUTE',
  170: 'HERTZ',
  171: 'THOUSANDTHS_OF_AN_INCH',
  172: 'THOUSANDTHS_OF_WATER_COLUMN',
  173: 'THOUSANDTHS_OF_MERCURY_COLUMN',
  174: 'NEWTON_PER_SQUARE_MILLIMETRE',
  175: 'VICKERS_HARDNESS_2',
  176: 'VICKERS_HARDNESS_5',
};

/**
 * The following units require translations as there is no standardized symbol defined
 * in the SI unit system. The symbols vary from locale to locale.
 *
 * See: https://www.nist.gov/pml/special-publication-330/sp-330-section-4
 */
export type TUnitSymbolRequiresTranslation = EUnitOfMeasurement.MINUTE
  | EUnitOfMeasurement.HOUR
  | EUnitOfMeasurement.DAY
  | EUnitOfMeasurement.WEEK
  | EUnitOfMeasurement.MONTH
  | EUnitOfMeasurement.YEAR;
